import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import Character from "../../CharacterCard";
import setCurrentPage from "src/Utils/setCurrentPage";

interface TemplateProps {
  data: DataCharacters;
}

const Template = (props: TemplateProps) => {
  const { bgImage, title, back, actions, headerRightText, headerLeftImage } =
    props.data;

  const templateType = "characters-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div style={styles.container}>
          <Title
            style={{ marginTop: "32px" }}
            type={templateType}
            text={title}
          />
          <div style={{ flex: 1, display: "flex", marginTop: "28px" }}>
            {props.data.characters.map(
              (character: CharacterType, index: number) => (
                <Character
                  key={index}
                  character={character}
                  type={templateType}
                />
              ),
            )}
          </div>
          <div style={styles.bottom}>
            <div>{back !== null && <Button {...back} />}</div>
            <div>
              <ButtonGroups>
                {actions &&
                  actions.map((action, index) => (
                    <Button key={index} {...action} />
                  ))}
              </ButtonGroups>
            </div>
          </div>
        </div>
      </Body>
    </BG>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "-webkit-fill-available",
    flexDirection: "column" as React.CSSProperties["flexDirection"],
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
  },
};

export default Template;
